// The "Ginastee Studio · Web" Meta dataset, next to the app's pixel (910007667122472) that
// public/index.html loads and inits. Its events go out with trackSingle only, so neither
// pixel receives the other's, and its automatic event detection is off: no button click is
// ever read as a sign-up. CompleteRegistration never leaves the browser: core sends it from
// the server, for qualified sign-ups only (contract 2.6.0). Without fbevents (blocked, tests)
// every call is a no-op.
export const STUDIO_PIXEL_ID = '1133248559647744';

let initialized = false;

const pixel = () => (typeof window !== 'undefined' && typeof window.fbq === 'function' ? window.fbq : null);

export function initStudioPixel() {
  const fbq = pixel();
  if (!fbq || initialized) return;
  try {
    fbq('set', 'autoConfig', false, STUDIO_PIXEL_ID);
    fbq('init', STUDIO_PIXEL_ID);
    initialized = true;
  } catch { /* Tracking never breaks the page. */ }
}

const send = (method, event, params) => {
  const fbq = pixel();
  if (!fbq) return;
  initStudioPixel();
  try { fbq(method, STUDIO_PIXEL_ID, event, params); } catch { /* Tracking never breaks the page. */ }
};

export const studioTrack = (event, params = {}) => send('trackSingle', event, params);
export const studioTrackCustom = (event, params = {}) => send('trackSingleCustom', event, params);

// Tests only: the next call inits again.
export const resetStudioPixel = () => { initialized = false; };
